module.exports = __webpack_public_path__ + "img/Turbilatex Reagents 03.2(mid).a5823d10.jpg";